// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"18":"c2aa0fcd","75":"c2aa0fcd","395":"c2aa0fcd","522":"c2aa0fcd"}[chunkId] + ".chunk.css";
};